import {Identifiable, Nameable, WithCoverAndLogo} from './identifiable';
import {Merchant} from './merchant';

export interface OrganizationSummary extends Nameable, Identifiable, WithCoverAndLogo {
  type: OrganizationType;

  isSponsor(): boolean;

  isMerchant(): boolean;
}

export interface Organization extends OrganizationSummary {
  mCardId: string;
  merchant?: Merchant;
  businessVerified: boolean;
}

export interface OrganizationAssetsUpdateModel extends Nameable, WithCoverAndLogo {
}

export enum OrganizationType {
  SPONSOR = 'SPONSOR',
  SPONSOR_WITH_MCARD = 'SPONSOR_WITH_MCARD',
  MERCHANT = 'MERCHANT'
}
